import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { RoutePath } from 'app/routing/routes';
import { ConfigService } from 'app/_services/config.service';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class MaintenanceGuard implements CanActivate {
    systemStatus: boolean;

    constructor(private configService: ConfigService, private router: Router) {
        this.configService.systemActive.subscribe((status) => (this.systemStatus = status));
    }

    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
        const self = this;
        const IsSystemActive = self.systemStatus;

        if (!IsSystemActive) {
            self.router.navigate([RoutePath.Maintenance]);
        }

        return IsSystemActive;
    }
}